// :: Dependencies
import { TRANSFER_LAST_DOCUMENT_SAVE } from "./mutation-types";
import { errorMessage, showMessage } from "@/services/MessageService";
import { firestore, firestoreField, storageRef } from "@/config/firebase";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { checkImagesMap } from "@/models/damage/CheckItemImages";
import * as localforage from "localforage";
import { imagesMap } from "@/models/damage/ActualStateImages";

export default {
  async getTransfers({ commit }, lastDocument) {
    loaderStart();
    try {
      // const branchOffices = await dispatch("getBranchOfficesAccess");
      const latestDocument = await firestore("transfers")
        .orderBy("lastUpdate", "desc")
        .limit(1)
        .get();
      const date = await latestDocument.docs[0].data().lastUpdate;

      let query = firestore("transfers")
        .where("lastUpdate", "==", date)
        .orderBy("date", "desc")
        .limit(10);

      // branchOffices.forEach((branchOffice) => {
      //   query.where("branch", "==", branchOffice);
      // });

      if (lastDocument) {
        query = firestore("transfers")
          .where("lastUpdate", "==", date)
          .orderBy("date", "desc")
          .startAfter(lastDocument)
          .limit(10);
      }
      const transfers = await query.get();
      let newLastDocument = transfers.docs[transfers.docs.length - 1];
      commit(TRANSFER_LAST_DOCUMENT_SAVE, newLastDocument);
      const transfersData = [];
      for (const transfer of transfers.docs) {
        transfersData.push({
          ...transfer.data(),
          date: transfer.data().date.toDate(),
          key: transfer.id
        });
      }
      loaderDone();
      return transfersData;
    } catch {
      errorMessage("Ha ocurrido un error al consultar las transferencias");
      loaderDone();
    }
  },
  async getDetail(_, id) {
    let dataOrder = {};
    try {
      const dataSnap = await firestore(`transfers`)
        .doc(id)
        .get();
      if (dataSnap.exists) {
        dataOrder = { ...dataSnap.data(), key: dataSnap.id };
        return dataOrder;
      } else {
        return null;
      }
    } catch (error) {
      errorMessage("No se puedo obtener los detalles de la orden");
    }
  },
  async createChecklistTransferRefs(_, data) {
    try {
      const itemRef = await firestore("transfers")
        .doc(data.id)
        .get();
      var itemPath = itemRef.ref.path;
      const checklistRef = await firestore(itemPath + "/checklist").doc();
      return checklistRef;
    } catch (error) {
      errorMessage(
        "No se pudo guardar el checklist, ocurrio un error inesperado."
      );
    }
  },
  async saveChecklist({ state }, data) {
    loaderStart();
    try {
      data.checklistRef.set(
        {
          date: firestoreField.serverTimestamp(),
          event: data.checklistType,
          lastUpdate: firestoreField.serverTimestamp()
        },
        { merge: true }
      );

      let checkItemImagesKeys = Object.values(checkImagesMap);
      const imagesObject = {};
      for (let x = 0; x < checkItemImagesKeys.length; x++) {
        const currentImageKey = data.path + "-" + checkItemImagesKeys[x];
        let currentImageObject = await localforage.getItem(currentImageKey);
        if (currentImageObject) {
          let imageType = currentImageObject.thumbnail.substring(
            "data:image/".length,
            currentImageObject.thumbnail.indexOf(";base64")
          );
          const imageURL = `${
            data.checklistRef.path
          }/checkItem/thumb-${currentImageKey}.${imageType}`;
          await storageRef
            .child(imageURL)
            .putString(currentImageObject.thumbnail, "data_url");
          let thumbImageCheckRef = await storageRef.child(imageURL);
          imagesObject[currentImageKey] = {
            thumb: await thumbImageCheckRef.getDownloadURL()
          };
          data.checklist.images = imagesObject;
          currentImageObject = null;
        }
      }
      const checklist = data.checklist;
      for (var i = 0; i < state.savedChecklists.length; i++) {
        if (state.savedChecklists[i].name == checklist.name) {
          state.savedChecklists.splice(i, 1);
        }
      }
      state.savedChecklists.push(checklist);

      state.savedChecklists.sort(function(a, b) {
        if (a.title > b.title) {
          return 1;
        }
        if (a.title < b.title) {
          return -1;
        }
        return 0;
      });
      data.checklistRef.set(
        {
          savedChecklists: state.savedChecklists,
          completed: false
        },
        { merge: true }
      );
      showMessage({
        message: "La incidencia se ha guardado correctamente",
        color: "success"
      });
    } catch (error) {
      errorMessage("Ocurrió un error inesperado al guardar");
    } finally {
      loaderDone();
    }
  },
  async saveChecklistSuccess({ rootState }, data) {
    try {
      data.checklistRef.set(
        {
          date: firestoreField.serverTimestamp(),
          lastUpdate: firestoreField.serverTimestamp(),
          event: data.checklistType
        },
        { merge: true }
      );
      data.checklistRef.get().then(async doc => {
        if (doc.exists) {
          if (doc.data().savedChecklists) {
            await doc.data().savedChecklists.forEach(element => {
              data.checklist.push(element);
            });
          }
          await data.checklistRef.set(
            {
              savedChecklists: data.checklist,
              completed: true,
              savedFuel: rootState.checklist.checklistFuelData,
              savedHorometro: rootState.checklist.horometro
            },
            { merge: true }
          );
        } else {
          await data.checklistRef.set({
            savedChecklists: data.checklist,
            completed: true,
            savedFuel: rootState.checklist.checklistFuelData,
            savedHorometro: rootState.checklist.horometro
          });
        }
      });
    } catch (error) {
      errorMessage("Ocurrió un error inesperado al guardar");
    }
  },
  async updateOrderStatus(_, transferID) {
    const checklistRef = await firestore("transfers").doc(transferID);
    const transferInfo = await checklistRef.get();
    if (transferInfo.data().statusMap) {
      if (transferInfo.data().statusMap.input) {
        checklistRef.set(
          {
            statusMap: {
              input: true,
              output: true
            }
          },
          { merge: true }
        );
      }
    } else {
      checklistRef.set(
        {
          statusMap: {
            input: true,
            output: false
          }
        },
        { merge: true }
      );
    }
  },
  async saveActualStateImages({ rootState }, data) {
    let actualStateImagesKeys = Object.values(imagesMap);
    const imagesObject = {};
    for (let x = 0; x < actualStateImagesKeys.length; x++) {
      const currentImageKey = data.path + "-" + actualStateImagesKeys[x];
      let currentImageObject = await localforage.getItem(currentImageKey);
      if (currentImageObject) {
        let imageType = currentImageObject.thumbnail.substring(
          "data:image/".length,
          currentImageObject.thumbnail.indexOf(";base64")
        );
        const imageURL = `${
          data.checklistRef.path
        }/actualState/thumb-${currentImageKey}.${imageType}`;
        await storageRef
          .child(imageURL)
          .putString(currentImageObject.thumbnail, "data_url");
        let thumbImageStateRef = await storageRef.child(imageURL);
        imagesObject[currentImageKey] = {
          thumb: await thumbImageStateRef.getDownloadURL()
        };
        /**
         * Clear images from check items and actual state
         * it's placed in this step because this functions
         * executes once at the end of the checklist completion
         */
        rootState.checklistImages.itemsActualState[currentImageKey] = null;
        rootState.checklistImages.itemsCheck = {};
      }
      currentImageObject = null;
    }

    data.checklistRef.set({ actualStateImages: imagesObject }, { merge: true });

    // clear local forage impormation to free user's memory
    localforage.clear();
  }
};
